import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import { clearMapping } from '../../../store/actions/metadata.actions';

const styles = () => ({
  text: {
    width: '100%',
    textAlign: 'right',
  },
});

const MappingClearContainer = ({
  disabled,
  classes,
  clearMapping, // eslint-disable-line no-shadow
}) => (
  <Typography className={classes.text}>
    <Button
      color="secondary"
      onClick={() => clearMapping()}
      disabled={disabled}
    >
      <Icon>clear_all</Icon>
      Clear mapping
    </Button>
  </Typography>
);

MappingClearContainer.propTypes = {
  clearMapping: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

MappingClearContainer.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(connect(null, { clearMapping })(MappingClearContainer));
